<template>
  <div style="width: 100%; height: 100%;">
    <Echart
      :options="options"
      id="TypeLine"
      height="100%"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart'
export default {
  data () {
    return {
      options: {},
      // 定义颜色
      colorList: {
        linearYtoG: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#f5b44d"
            },
            {
              offset: 1,
              color: "#28f8de"
            }
          ]
        },
    linearGtoB: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            {
              offset: 0,
              color: "#1f71ab"
            },
            {
              offset: 1,
              color: "#e2960f"
            }
          ]
        },
        linearBtoG: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            {
              offset: 0,
              color: "#1f71ab"
            },
            {
              offset: 1,
              color: "#e2960f"
            }
          ]
        },
        areaBtoG: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "rgba(226, 150, 15, 0.49)"
            },
            {
              offset: 1,
              color: "rgba(196, 196, 196, 0)"
            }
          ],
          global: false,
        }
      }
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler (newData) {
        if(!newData){
          return;
        }
        this.options = {
          legend: {
            top: 10,
          },

          tooltip: {
            trigger: "item"
          },
          grid: {
            top: 60,
            left: 40,
            right: 30,
            bottom: 30,
          },
          xAxis: {
            type: "category",
            position: "bottom",
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                opacity: 1
              }
            },
            axisLabel: {
              color: "#000000",
              fontWeight: 500,
              fontSize: 14
            },
            data: newData.weekCategory
          },
          // 下方Y轴
          yAxis: {
            splitNumber: 10,
            axisLine: {
              lineStyle: {
                opacity: 1
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type:'dashed',
                color: "#000000",
                opacity: 0.2
              }
            },
            axisLabel: {
              color: "#000000",
              fontSize: 14,
              fontWeight: 500,
            }
          },
          visualMap: {
            type: 'piecewise',
            show: false,
            dimension: 0,
            seriesIndex: 0,
            pieces: [
              {
                gt: 1,
                lt: 3,
                color: 'rgba(0, 0, 180, 0.4)'
              },
              {
                gt: 5,
                lt: 7,
                color: 'rgba(0, 0, 180, 0.4)'
              }
            ]
          },
          series: [
            {
              type: "line",
              smooth: true,
              symbol: "emptyCircle",
              symbolSize: 6,
              itemStyle: {
                normal: {
                  color: "#fff"
                }
              },
              lineStyle: {
                normal: {
                  color: this.colorList.linearGtoB,
                  width: 4
                }
              },
              areaStyle: {
                normal: {
                  color: this.colorList.areaBtoG
                }
              },
              data: newData.weekLineData,
              lineSmooth: true,
              tooltip: {
                position: "top",
                formatter: "{c}人",
                backgroundColor: '#FFFFFF',
                padding: 6,
                textStyle: { // 提示框浮层的文本样式。
                  color: '#6f8199',
                  fontFamily: 'sans-serif',
                  fontWeight: 500,
                  fontSize: 14,
                },
              }
            },

          ]
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/echart/TypeLine2/chart.vue